import React from 'react'
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components'

type GridProps = {
   children: JSX.Element | JSX.Element[]
   className?: string
}
const useStyles = makeStyles({
   grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: tokens.spacingHorizontalL,
      '@media (min-width: 1200px)': {
         gap: tokens.spacingHorizontalXXL,
      },
   },
})
export const Grid = ({ children, className }: GridProps) => {
   const classes = useStyles()
   return <article className={mergeClasses(classes.grid, className)}>{children}</article>
}
